<template>

        <div class="container-fluid  pt-2" >
            <div class="container pt-5">

            </div>
            <div class="container">
                <div class="row">
                    <div class="col-md-6 col-12">
                        <div class="py-3">
                            <h4 class="text-weight-900">Salary Advance Applications</h4>
                        </div>
                    </div>
                    <div class="col-md-6 col-12">

                    </div>

                </div>

            <b-table
                    sticky-header
                    hover
                    :items="salaryadvtable.items"
                    :fields="salaryadvtable.fields"
                    sort-icon-left
                    responsive="sm"


            >
                <template #cell(index)="data">
                    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                    <span>{{ data.index + 1 }}</span>

                </template>
                <template #cell(status)="data">
                    <!--<span style="background: #0b2e13; width:30px !important; height:80px" class="text-light">{{ data.index + 1 }}</span>-->
                    <span v-if="data.item.status === null"><span class="badge badge-pill badge-primary py-2 px-3 underline-primary mr-1" v-on:click="ActionAdvance('approve',data.item.advance_id)">Approve</span><span class="badge badge-pill badge-danger py-2 px-3 underline-primary" v-on:click="ActionAdvance('reject',data.item.advance_id)">Reject</span></span>
                    <span  v-else-if="data.item.status === 1"><h6 class="badge badge-pill badge-success py-2 px-3">Approved</h6></span>
                    <span v-else="data.item.status === 0"><h6 class="badge badge-pill badge-danger py-2 px-3">Declined</h6></span>


                </template>


            </b-table>


        </div>





    </div>
</template>

<script>
    export default {
        name: "salaryadvances",
        data(){
            return{
                salaryadvtable:{
                    items:[],
                    fields:[
                        "index",
                        {key:"applicant",sortable:true},
                        {key:"amount",sortable:true},
                        {key:"date",sortable:true},
                        {key:"status",sortable:true},
                    ]
                }
            }
        },
        methods:{
            GetSalaryAdvance()
            {
                axios.get('/api/salary-advances').then(results=>{
                    console.log(results.data);
                    let salaryarray = [];
                    let user_name = '';

                    $.each(results.data,function (key,value) {
                        if(value.employee !== null)
                        {
                            user_name = value.user.full_name;
                        }
                        salaryarray.push(
                            {applicant:user_name,amount:value.amount,date:moment(value.created_at).fromNow(),status:value.status,advance_id:value.id}                        );
                    });
                    console.log(salaryarray);
                    this.salaryadvtable.items = salaryarray

                }).catch(error=>{
                    console.log(error)
                })
            },
            ActionAdvance(action,id){
                console.log(id);
                axios.post('/api/approve-advance',{action:action,advance_id:id}).then(results=>{

                    this.$toasts.push({
                        type: results.data.type,
                        message: results.data.message,
                    });
                    this.GetSalaryAdvance();
                }).catch(error=>{
                    console.log(error.data)
                });
            },
        },
        mounted() {
            this.GetSalaryAdvance()
        }
    }
</script>

<style scoped>

</style>